import React from 'react';

const Privacy = () => {
  return (
    <div className="min-h-screen">
      <section className="bg-gradient-to-br from-indigo-600 via-purple-600 to-indigo-800 text-white py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold mb-4">Privacy Policy</h1>
          <p className="text-xl text-indigo-100">Last updated: August 2025</p>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="prose prose-lg max-w-none">
          <p className="text-xl text-gray-600 mb-8">
            TECHSPR is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information.
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-12">Information We Collect</h2>
          <p className="text-gray-700 mb-4">
            We collect information that you provide directly to us, including:
          </p>
          <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-8">
            <li>Name, email address, and contact information</li>
            <li>Company name and job title</li>
            <li>Information you provide in forms or communications</li>
            <li>Technical information about how you interact with our website</li>
          </ul>

          <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-12">How We Use Your Information</h2>
          <p className="text-gray-700 mb-4">
            We use the information we collect to:
          </p>
          <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-8">
            <li>Respond to your inquiries and provide customer support</li>
            <li>Send you information about our services and updates</li>
            <li>Improve our website and services</li>
            <li>Comply with legal obligations</li>
          </ul>

          <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-12">Data Security</h2>
          <p className="text-gray-700 mb-8">
            We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-12">Your Rights</h2>
          <p className="text-gray-700 mb-4">
            You have the right to:
          </p>
          <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-8">
            <li>Access your personal information</li>
            <li>Correct inaccurate information</li>
            <li>Request deletion of your information</li>
            <li>Opt-out of marketing communications</li>
          </ul>

          <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-12">Contact Us</h2>
          <p className="text-gray-700 mb-8">
            If you have questions about this Privacy Policy, please contact us at privacy@techspr.com
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;